/* eslint-disable max-len */
export default {
  CareConnect: 'CareConnect',
  Onboarding: 'Onboarding',
  Helmet: {
    title: 'Quilt: Form',
  },
  EditMode: {
    Cancel: 'Cancel',
    Save: 'Save',
  },
  Common: {
    Back: 'Back',
    Continue: 'Continue',
    Finish: 'Finish',
  },
  CareRecipientInfo: {
    Title: 'Before we begin...',
    Description: 'Let\'s start with some basic information about care recipient.',
    FullNameLabel: 'Full name of care recipient',
    DobLabel: 'Date of birth',
    AddressLabel: 'Address',
    AddressPlaceholder: '123 Main Street, Ottawa, ON',
  },
  FormStep: {
    Previous: 'Previous',
    Next: 'Next',
    Submit: 'Submit',
    Skip: 'Skip',
    Progress: '#{current} of #{total}',
    ProgressEmpty: '0 of 0',
    WhyAskingTitle: 'Why are we asking this?',
    WhyAskingBody: 'Your experience helps us match you with compatible clients.',
  },
  FormStepper: {
    More: '#{count} more',
  },
  Inputs: {
    OtherPlaceholder: 'Specify other option...',
    TextPlaceholder: 'Enter your response',
  },
  IntakeForms: {
    Experience: {
      Title: 'Experience',
      Description: 'Experience Form',
      Questions: {
        ExperienceYears: {
          Label: 'How long have you been a professional caregiver in Canada?',
          Options: {
            OneTwo: '1-2 Years',
            TwoFive: '2-5 Years',
            MoreFive: 'More than 5 Years',
            NoExp: 'No Experience',
          },
        },
        CareSettings: {
          Label: 'What kind of care settings have you worked in? (select all that apply)',
          Options: {
            Private: 'Private homes (one-on-one care)',
            Retirement: 'Retirement or long-term care homes',
            Public: 'Public / government care programs',
            CommunityPrograms: 'Community care programs',
            Hospitals: 'Hospitals',
            Other: 'Other',
          },
        },
        Accreditations: {
          Label: 'What accreditations do you hold? (select all that apply)',
          Options: {
            PSW: 'Personal Support Worker (PSW)',
            DSW: 'Developmental Service Worker (DSW)',
            CSW: 'Community Support Worker (CSW)',
            HCA: 'Health Care Aide (HCA)',
            Nursing: 'Nursing (RN / RPN)',
            NursingStudent: 'Nursing Student (actively enrolled)',
            Other: 'Other',
          },
        },
        CPRFirstAid: {
          Label: 'Do you hold a valid CPR/BLS and First Aid certificate?',
          Options: {
            Yes: 'Yes',
            No: 'No',
          },
        },
        CareTasks: {
          Label: 'What care tasks have you done before? (select all that apply)',
          Options: {
            MemoryCare: 'Memory care (dementia, reminders)',
            MobilitySupport: 'Mobility support (walking, transfers)',
            PersonalCare: 'Personal care (bathing, dressing)',
            MedicationReminders: 'Medication reminders',
            MealPreparation: 'Meal preparation',
            LightHousekeeping: 'Light housekeeping',
            Other: 'Other',
          },
        },
      },
    },
    Contact: {
      Title: 'Contact',
      Description: 'Contact Form',
      Pages: {
        Name: {
          Title: 'Contact Details',
          Prompt: 'What\'s your name?',
        },
        Address: {
          Title: 'Contact Details',
          Prompt: 'What\'s your home address?',
        },
        ContactInfo: {
          Title: 'Contact Details',
          Prompt: 'What\'s your contact information?',
        },
      },
      Questions: {
        FirstName: {
          Label: 'First name',
          Placeholder: 'Jane',
        },
        LastName: {
          Label: 'Last name',
          Placeholder: 'Doe',
        },
        StreetAddress: {
          Label: 'Street address (number + street name)',
          Placeholder: '123 Main Street',
        },
        ApartmentUnit: {
          Label: 'Apartment / Unit (optional)',
          Placeholder: 'Apartment 1A',
        },
        City: {
          Label: 'City',
          Placeholder: 'Toronto',
        },
        Province: {
          Label: 'Province / Territory',
          Placeholder: 'Ontario',
          Options: {
            AB: 'Alberta',
            BC: 'British Columbia',
            MB: 'Manitoba',
            NB: 'New Brunswick',
            NL: 'Newfoundland and Labrador',
            NT: 'Northwest Territories',
            NS: 'Nova Scotia',
            NU: 'Nunavut',
            ON: 'Ontario',
            PE: 'Prince Edward Island',
            QC: 'Quebec',
            SK: 'Saskatchewan',
            YT: 'Yukon',
          },
        },
        PostalCode: {
          Label: 'Postal code',
          Placeholder: 'A1A 1A1',
        },
        PhoneNumber: {
          Label: 'Phone number',
          Placeholder: '(123) 456-7890',
        },
        Email: {
          Label: 'Email',
          Placeholder: 'your@email.com',
        },
        PrivacyPolicy: {
          Label: 'I agree to CareQuilt\'s <a href="https://carequilt.ca/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #DA7955;">Privacy Policy</a> and consent to my information being reviewed for application purposes.',
        },
      },
    },
  },
  Final: {
    Title: 'Next steps',
    WeReview: {
      Title: 'We review your application',
      Details: 'If it looks good, you will get an email within 30 minutes with an invite.',
    },
    SetUpProfile: {
      Title: 'You set up your profile',
      Details: 'You answer simple questions about your experience, personality, and what kind of work you want. This helps us make your profile.',
    },
    CareOffers: {
      Title: 'You get care offers',
      Details: 'You start getting offers from families looking for a private, in-home caregiver.',
    },
  },
};
